import { useState } from 'react';

import Link from 'next/link';
import { IconType } from 'react-icons';
import { BsCreditCard2FrontFill } from 'react-icons/bs';
import {
  HiChevronDown,
  HiLibrary,
  HiOfficeBuilding,
  HiPhone,
} from 'react-icons/hi';
import { RiTimeLine } from 'react-icons/ri';
import { useWindowSize } from 'usehooks-ts';

import { TkTayaraToken } from '@/tayara-kit/icons';
import Text from '@/tayara-kit/Text';

export interface IPaymentOption {
  id: number;
  label: string;
  description: string;
  icon: IconType;
}

export const SecondSectionContent = () => {
  const windowSize = useWindowSize();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const PAYMENT_METHODS: IPaymentOption[] = [
    {
      id: 0,
      label: 'Carte bancaire',
      description: 'Paiement en ligne',
      icon: BsCreditCard2FrontFill,
    },
    {
      id: 1,
      label: 'Virement bancaire',
      description: 'UIB, Zitouna, La Poste',
      icon: HiLibrary,
    },
    {
      id: 3,
      label: 'Dans nos locaux',
      description: 'Par chéque ou en espéce',
      icon: HiOfficeBuilding,
    },
  ];

  const offerCardContent = [
    {
      price: '20 TND',
      secondPrice: '',
      icon: TkTayaraToken,
      totalTokens: '200 Jetons',
      bonusTokens: '+ 0 Jetons bonus',
      period: 'Valable 30 jours',
    },
    {
      price: '50 TND',
      secondPrice: '500 TND',
      icon: TkTayaraToken,
      totalTokens: '500 Jetons',
      bonusTokens: '+ 10 Jetons bonus',
      period: 'Valable 30 jours',
    },
    {
      price: '100 TND',
      secondPrice: '',
      icon: TkTayaraToken,
      totalTokens: '1000 Jetons',
      bonusTokens: '+ 50 Jetons bonus',
      period: 'Valable 30 jours',
    },
    {
      price: '150 TND',
      secondPrice: '',
      icon: TkTayaraToken,
      totalTokens: '1500 Jetons',
      bonusTokens: '+ 100 Jetons bonus',
      period: 'Valable 30 jours',
    },
  ];

  return (
    <>
      <div className="flex flex-col mx-auto justify-center items-center w-full md:w-4/6 h-fit mb-10 mt-12 md:mt-16 md:mb-16 ">
        <Text
          text="Achetez des Jetons facilement"
          as="h3"
          className="text-2xl md:text-3xl font-bold text-center text-info"
        />
        <div className="flex flex-col">
          <p
            className={`text-sm md:text-lg text-center text-neutral-700 mt-7  ${
              !isExpanded && windowSize.width < 1100
                ? 'whitespace-pre-line line-clamp-2'
                : ''
            }`}
          >
            Que vous vendiez ou présentiez des produits, les Jetons vous aident
            à avoir un impact. <br /> Mettez en avant vos annonces et
            démarquez-vous de la concurrence en gagnant un avantage en matière
            de visibilité et d&apos;engagement.
          </p>

          {/* Show more button */}
          {windowSize.width < 1100 && (
            <button
              className="text-xs flex justify-center items-center gap-x-1 text-primary font-medium mt-2"
              onClick={() => toggleExpanded()}
            >
              <Text
                as="span"
                text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
                className="truncate"
              />
              <HiChevronDown
                size={18}
                className={`${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
          )}
        </div>
        <div className="w-fit flex items-center mt-7">
          <Link
            href={{ pathname: '/buy-tokens' }}
            passHref
            aria-label="Acheter de t-tokens"
            className="w-full md:w-fit lg:w-fit mx-auto"
          >
            <button className="w-full md:w-fit lg:w-fit flex flex-col mx-auto rounded-xl border-[1.5px] border-gray-400 bg-gradient-to-r from-blue-700 via-blue-500 to-blue-400 !text-white hover:from-blue-700 hover:to-blue-600 group shadow-sm  hover:shadow-none">
              <div className="flex gap-x-4 mx-auto items-center">
                <div className="flex flex-col my-3">
                  <span className="flex items-center text-base font-semibold mx-8 lg:mx-10 leading-6">
                    Achetez des <TkTayaraToken className="mx-2" />
                    Jetons
                  </span>
                </div>
              </div>
            </button>
          </Link>
        </div>
        <Text
          text="Donnez un coup de pouce à vos annonces dès aujourd'hui!"
          as="p"
          className="text-lg lg:text-xl xl:text-3xl font-light italic text-center text-neutral-700 mt-12"
        />
      </div>
      <Text
        text="Achetez des Jetons en toute simplicité"
        as="h3"
        className="text-base md:text-lg lg:text-xl font-bold text-center text-neutral-700 my-6"
      />
      <div className="flex flex-col mb-12">
        <p
          className={`text-sm lg:text-sm xl:text-base text-center text-neutral-700 mx-auto md:mx-60  ${
            !isExpanded && windowSize.width < 1100
              ? 'whitespace-pre-line line-clamp-2'
              : ''
          }`}
        >
          L&apos;achat de Jetons est rapide et facile. Il vous suffit de
          naviguer vers la section d&apos;achat de Jetons, de choisir le forfait
          qui convient le mieux à vos besoins, puis de suivre les étapes simples
          pour finaliser votre achat. Une fois vos Jetons acquis, vous pourrez
          les utiliser pour mettre en avant vos annonces et profiter d&apos;une
          visibilité accrue.
        </p>

        {/* Show more button */}
        {windowSize.width < 1100 && (
          <button
            className="text-xs flex justify-center items-center gap-x-1 text-primary font-medium mt-1"
            onClick={() => toggleExpanded()}
          >
            <Text
              as="span"
              text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
              className="truncate"
            />
            <HiChevronDown
              size={18}
              className={`${isExpanded ? 'rotate-180' : ''}`}
            />
          </button>
        )}
      </div>

      {/* First offers */}
      <div className="flex flex-col justify-center items-center m-1 xl:mx-36 px-2 py-10  bg-white/40 rounded-3xl outline outline-[1px] outline-dashed outline-info/40 ">
        {/* Section's logos */}
        <div className="w-full flex flex-wrap items-center justify-center gap-x-4 md:gap-x-10 ">
          <div className=" h-full my-2 rounded-xl flex flex-col items-center justify-center text-neutral-600 cursor-pointer group">
            <div className="flex flex-col items-center">
              <div className="flex justify-center items-center w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] rounded-full border-[1px] border-yellow-400">
                <HiLibrary size={30} className="w-4 h-4 lg:w-8 lg:h-8" />
              </div>
              <data className="mt-2 text-2xs lg:text-sm text-center font-bold text-md truncate">
                Virement bancaire
              </data>
            </div>

            {/* Bonus detailer */}
            <div className="flex items-center flex-col">
              <p className="text-center text-3xs lg:text-xs leading-tight">
                UIB - Agence Palmier du lac , Zitouna - Agence l&apos;Aouina, La
                Poste
              </p>
            </div>
          </div>

          <div className="h-full my-2 rounded-xl flex flex-col items-center justify-center text-neutral-600 cursor-pointer group">
            <div className="flex flex-col items-center">
              <div className="flex justify-center items-center w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] rounded-full border-[1px] border-yellow-400">
                <HiOfficeBuilding size={30} className="w-4 h-4 lg:w-8 lg:h-8" />
              </div>
              <data className="mt-2 text-2xs lg:text-sm text-center font-bold text-md truncate">
                Dans nos locaux
              </data>
            </div>

            {/* Bonus detailer */}
            <div className="flex items-center flex-col">
              <p className="text-center text-3xs lg:text-xs leading-tight">
                Par chéque ou en espéce
              </p>
            </div>
          </div>

          {/* Section's logo */}
          <div className="  h-full flex flex-col items-center justify-center text-neutral-600 cursor-pointer group">
            <div className="flex flex-col items-center">
              <div className="flex justify-center items-center w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] rounded-full border-[1px] border-yellow-400">
                <BsCreditCard2FrontFill
                  size={30}
                  className="w-4 h-4 lg:w-8 lg:h-8"
                />
              </div>
              <data className="mt-2 text-2xs lg:text-sm text-center font-bold text-md truncate">
                Carte bancaire
              </data>
            </div>

            {/* Bonus detailer */}
            <div className="flex items-center flex-col">
              <p className="text-center text-3xs lg:text-xs leading-tight">
                Paiement en ligne
              </p>
            </div>
          </div>
        </div>
        {/* Offers Section's title */}

        <p className="flex gap-y-6 lg:flex-row flex-col justify-center items-center text-sm md:text-lg text-center text-neutral-700 font-bold mt-6 mb-10 mx-auto md:mx-20 gap-x-2">
          Pour tout achat par chèque, en espèces, ou par virement bancaire
          <span className="flex font-bold">
            1
            <TkTayaraToken size={24} className="mx-1 mb-[1px]" />
            Jeton = 100 Millimes
          </span>
        </p>
        {/* Offers cards */}
        <div className="flex justify-center flex-wrap xl:flex-nowrap gap-4 z-50 pb-10">
          {offerCardContent.map((offerContent) => (
            <div
              key={''}
              className="my-2 flex justify-center items-center gap-6"
            >
              <div className="flex flex-col justify-center items-center w-[16rem] h-full  p-4 rounded-2xl border-[1px] border-neutral-300 bg-white/80 border-t-8 border-t-yellow-600/60 bg-from-yellow-[#EED08E]/50 bg-gradient-to-b from-white via-[#EED08E]/50 to-white">
                <div className="flex flex-col justify-center items-center">
                  <Text
                    text={offerContent.price}
                    as="span"
                    className="text-4xl text-center font-extrabold text-neutral-600 flex-1 mt-1 mx-4"
                  />
                  <TkTayaraToken
                    size={80}
                    className="my-6 text-yellow-600/60 bg-white rounded-full"
                  />
                </div>
                <Text
                  text={offerContent.totalTokens}
                  as="span"
                  className="text-xl text-center font-extrabold text-neutral-600  my-2 mx-4"
                />
                <div className="flex flex-col my-4 gap-y-2">
                  <div className="flex justify-center items-center gap-x-2">
                    <RiTimeLine size={20} className="mr-1" />
                    <Text
                      text={offerContent.period}
                      as="span"
                      className="text-sm text-center font-semibold text-neutral-600 "
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* <div className=" w-full h-full flex flex-col items-center justify-center text-neutral-600 cursor-pointer group border-t-[1px] border-info/50 border-dashed pt-10">
          <div className="flex flex-col items-center">
            <div className="flex justify-center items-center w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] rounded-full border-[1px] border-yellow-400">
              <BsCreditCard2FrontFill size={30} className="w-4 h-4 lg:w-8 lg:h-8" />
            </div>
            <data className="text-center font-bold text-mdtruncate">
              Carte bancaire
            </data>
          </div>

          <div className="flex items-center flex-col">
            <p className="text-center text-3xs lg:text-xs leading-tight">
              Paiement en ligne
            </p>
          </div>
        </div>
        
        <p className="text-sm md:text-lg text-center text-neutral-700 mt-6 mb-10 mx-auto md:mx-20">
          Pour tout <b>paiement en ligne supérieur à 10 Dinars</b>, bénéficiez
          d&apos;<b>une réduction de 10%</b>
        </p> */}

        {/* <div className="flex justify-center flex-wrap lg:flex-nowrap gap-4 ">
          {offerCardContent.slice(1, 4).map((offerContent) => (
            <div
              key={''}
              className="my-2 flex justify-center items-center gap-6"
            >
              <div className="flex flex-col justify-center items-center w-[16rem] h-full  p-4 rounded-2xl border-[1px] border-neutral-300 bg-white/80 border-t-8 border-t-yellow-600/60 bg-from-yellow-[#EED08E]/50 bg-gradient-to-b from-white via-[#EED08E]/50 to-white">
                <div className="flex flex-col justify-center items-center">
                  <Text
                    text={offerContent.price}
                    as="span"
                    className="text-xl line-through text-center font-extrabold text-neutral-600 flex-1 mt-1 mx-4"
                  />
                  <Text
                    text={offerContent.secondPrice}
                    as="span"
                    className="text-4xl text-center font-extrabold text-neutral-600 flex-1 mt-1 mx-4"
                  />
                  <TkTayaraToken
                    size={80}
                    className="my-6 text-yellow-600/60 bg-white rounded-full"
                  />
                </div>
                <Text
                  text={offerContent.totalTokens}
                  as="span"
                  className="text-xl text-center font-extrabold text-neutral-600  my-2 mx-4"
                />
                <div className="flex flex-col my-4 gap-y-2">
                  <div className="flex justify-center items-center gap-x-2">
                    <TkTayaraToken size={19} className="text-green-600" />
                    <Text
                      text={offerContent.bonusTokens}
                      as="span"
                      className="text-sm text-center font-semibold text-green-600 "
                    />
                  </div>
                  <div className="flex justify-center items-center gap-x-2">
                    <RiTimeLine size={20} className="mr-1" />
                    <Text
                      text={offerContent.period}
                      as="span"
                      className="text-sm text-center font-semibold text-neutral-600 "
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div> */}

        <div className="flex flex-col justify-center items-center gap-x-5 my-4">
          <Text
            text="Choisissez votre méthode d`achat de Jetons"
            as="h3"
            className="text-base md:text-lg lg:text-xl font-bold text-center text-neutral-700 my-8"
          />

          <div className="flex flex-col mx-auto md:mx-40 mb-10">
            <p
              className={`text-sm lg:text-sm xl:text-base text-center text-neutral-700  ${
                !isExpanded && windowSize.width < 1200
                  ? 'whitespace-pre-line line-clamp-2'
                  : ''
              }`}
            >
              L&apos;achat de Jetons est conçu pour être pratique et flexible.
              Vous avez le choix entre plusieurs méthodes sécurisées pour
              acquérir vos Jetons. Optez pour le paiement en ligne par carte de
              crédit ou par virement bancaire. Si vous préférez une approche
              plus personnelle, vous pouvez également nous rendre visite dans
              nos locaux pour effectuer votre achat.
            </p>

            {/* Show more button */}
            {windowSize.width < 1200 && (
              <button
                className="text-xs flex justify-center items-center gap-x-1 text-primary font-medium mt-2"
                onClick={() => toggleExpanded()}
              >
                <Text
                  as="span"
                  text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
                  className="truncate"
                />
                <HiChevronDown
                  size={18}
                  className={`${isExpanded ? 'rotate-180' : ''}`}
                />
              </button>
            )}
          </div>

          <div className="flex flex-wrap justify-center items-center md:gap-5  gap-8 md:mt-0">
            {PAYMENT_METHODS.map((paymentMethod) => (
              <Link
                key={paymentMethod.id}
                href={{ pathname: '/buy-tokens' }}
                passHref
                aria-label="Acheter de t-tokens"
                className=""
              >
                <div className="p-4 border-2 bg-white/80 border-stone-100 md:w-[230px] w-fit md:h-[230px] h-fit rounded-xl flex flex-col items-center justify-center text-neutral-500 cursor-pointer group">
                  <div className="flex flex-col items-center group-hover:text-yellow-600/60">
                    <paymentMethod.icon
                      size={windowSize.width < 500 ? 40 : 70}
                      className=""
                    />
                    <data className="font-bold md:text-lg">
                      {paymentMethod.label}
                    </data>
                  </div>

                  {/* Bonus detailer */}
                  <div className="flex items-center flex-col">
                    <p className="text-center text-3xs lg:text-xs leading-tight">
                      {paymentMethod.description}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center  w-full mx-auto pb-10">
        <Text
          text="Vous avez une question?"
          as="h3"
          className="text-lg font-bold text-center text-neutral-700 mt-12"
        />
        <a
          href={'/contact'}
          target="_blank"
          className=" text-sm lg:text-sm xl:text-base text-center underline text-neutral-700 mt-2 "
        >
          Contactez-nous
        </a>
        <div className="flex text-neutral-700 flex-col items-center ">
          <span className=" flex flex-col items-center text-center">
            <span className="text-sm my-2 font-light italic">Ou</span> Veuillez
            contacter le
            <span className="flex items-center gap-x-1 mt-1 font-bold text-stone-600 ">
              <HiPhone size={16} className="mt-[1px]" />
              +216 95 256 201{' '}
            </span>
          </span>
        </div>
      </div>
    </>
  );
};
